import React, { useState } from 'react';

type UseViewModelReturn = {
  LONGEST_REASON: string;
  reason: string;
  handleReasonTypeChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  handleSubmit: () => void;
};

const useViewModel = (
  onSubmit: (reason: string) => void
): UseViewModelReturn => {
  const LONGEST_REASON = 'Name does not match with reference number';
  const [reason, setReason] = useState<string>(undefined);

  const handleReasonTypeChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ): void => {
    setReason(event.target.value);
  };

  const handleSubmit = (): void => {
    onSubmit(reason);
  };

  return {
    LONGEST_REASON,
    reason,
    handleReasonTypeChange,
    handleSubmit,
  };
};

export default useViewModel;
